function navbar() {
	var navbar = {
		open: false,
		readyToChange: true,
		hamburgerListener: $("#navbar-hamburger").find(
			".navbar__hamburger-listener"
		),
		hamburger: $("#navbar-hamburger"),
		hamburgerActiveClass: "navbar__hamburger--active",
		menu: $("#navbar-right"),
		mobileLogin: $(".header-mobile-login"),
		changeMenuDisplay: function () {
			if ($(window).width() > 1024) {
				navbar.menu.show();
			} else {
				if (this.open) {
					this.menu.show();
					this.open = true;
					this.hamburger.addClass(this.hamburgerActiveClass);
				} else {
					this.menu.hide();
					this.open = false;
					this.hamburger.removeClass(this.hamburgerActiveClass);
				}
			}
		},
		toggle: function () {
			if (this.open && this.readyToChange) {
				this.hamburger.removeClass(this.hamburgerActiveClass);
				this.readyToChange = false;
				this.menu.slideUp(200, function () {
					navbar.readyToChange = true;
				});
			} else {
				this.hamburger.addClass(this.hamburgerActiveClass);
				this.readyToChange = false;
				this.menu.slideDown(200, function () {
					navbar.readyToChange = true;
				});
			}
			this.open = !this.open;
		}
	};

	$(window).on("resize", function () {
		navbar.changeMenuDisplay();
	});

	navbar.hamburgerListener.on("click", function () {
		navbar.toggle();
	});

	$(".navbar-items-group__item-text").on("click", function (e) {
		window.location.href = $(e.target).find("a").attr("href");
	});

	navbar.changeMenuDisplay();
}
